// import * as Turbo from "@hotwired/turbo"
import { gsap } from "gsap"
import * as Vivus from "vivus";

export default class Transitions {

  constructor() {
    this.init()
  }

  init(){
    this.setupShadeBtns()
    this.setupDefaultBtns()
  }

  dealoc(){
    console.log('dealoc')
  }

  setupTurboEvents(){
    window.addEventListener('turbo:load', (event)=> {
      this.init()
    }, true);

    window.addEventListener('turbo:visit', (event)=> {
      this.dealoc()
    }, true);
  }

  setupShadeBtns(){
    this.shadeBtns = document.querySelectorAll('.shade-btn')
    this.shadeBtns.forEach((btn)=>{
      const svg = btn.querySelector('svg')
      if(svg){
        const svgPath = new Vivus(svg,{
          start:'manual'
        })
        svgPath.setFrameProgress(1)
      }
      const tl = gsap.timeline({
        paused:true
      })
      .to(btn.querySelector('span'),{
        yPercent:-100,
        autoAlpha:0,
        duration:.25
      })
      .set(btn.querySelector('span'),{
        yPercent:100
      })
      .to(btn.querySelector('span'),{
        yPercent:0,
        autoAlpha:1,
        duration:.25
      })

      const shadowTl = gsap.timeline({
        paused:true
      })
      .to(btn.querySelector('.top-rect'),{
        y:-1,
        x:-1,
        backgroundColor: '#E8CFC2',
        duration:.25
      },'same')
      .to(btn.querySelector('.bottom-rect'),{
        y:1,
        x:1,
        duration:.125
      },'same')

      btn.addEventListener('mouseenter',()=>{
        // if(svgPath){
        //   svgPath.stop().reset().play(2);
        // }
        if(!tl.isActive()){
          tl.progress(0).play()
        }
        shadowTl.play()
      })
      btn.addEventListener('mouseleave',()=>{
        shadowTl.reverse()
      })
    })
  }

  setupDefaultBtns(){
    this.defaultBtns = document.querySelectorAll('.button')
    this.defaultBtns.forEach((btn)=>{
      let offset = 3
      let negativeOffset = offset*-1
      if(!btn.classList.contains('button--s')){
        offset = '0.5em'
        negativeOffset = '-0.5em'
      }
      const svg = btn.querySelector('svg')
      let svgPath = null

      if(svg){
        svgPath = new Vivus(svg,{
          start:'manual'
        })
        if(svgPath){
          svgPath.setFrameProgress(1)
        }
      }

      
      const tl = gsap.timeline({
        paused:true
      })
      .to(btn.querySelector('span'),{
        yPercent:-100,
        autoAlpha:0,
        duration:.25
      })
      .set(btn.querySelector('span'),{
        yPercent:100
      })
      .to(btn.querySelector('span'),{
        yPercent:0,
        autoAlpha:1,
        duration:.25
      })

      const shadowTl = gsap.timeline({
        paused:true,
        autoKill: false
      })
      .to(btn.querySelector('.top-rect'),{
        y:negativeOffset,
        x:negativeOffset,
        duration:.25
      },'same')
      .fromTo(btn.querySelector('.bottom-rect'),{
        y:0,
        x:0,
        autoAlpha:0
      },{
        y:offset,
        x:offset,
        autoAlpha:1,
        duration:.125
      },'same')

      btn.addEventListener('mouseenter',()=>{
        if(btn.classList.contains('disabled')){
          return false
        }
        // if(svg && svgPath){
        //   svgPath.stop().reset().play(2);
        // }
        

        if(!tl.isActive()){
          tl.progress(0).play()
        }
        shadowTl.play()
      })
      btn.addEventListener('mouseleave',()=>{
        shadowTl.reverse()
      })
    })
  }
}